import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import './Blog.css';

function BlogDetail() {
  const API_URL = 'https://www.fintexl.com'; // ✅ Added this

  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/api/blogs/${id}`) // ✅ Updated URL
      .then(res => {
        if (!res.ok) {
          throw new Error('Blog not found');
        }
        return res.json();
      })
      .then(data => setBlog(data))
      .catch(err => setError(err.message));
  }, [id]);

  if (error) {
    return (
      <div className="blog-detail">
        <h2>Error</h2>
        <p>{error}</p>
        <Link to="/blog">Back to Blogs</Link>
      </div>
    );
  }

  if (!blog) {
    return <div className="blog-detail">Loading...</div>;
  }

  return (
    <div className="blog-detail">
      <h2>{blog.title}</h2>
      <img src={blog.previewUrl} alt={blog.title} /> {/* ✅ Preview URL already complete */}
      <p>{blog.description}</p>
      <a href={blog.originalUrl} target="_blank" rel="noopener noreferrer">
        View Full Blog Document
      </a>
      <br />
      <Link to="/blog">Back to Blogs</Link>
    </div>
  );
}

export default BlogDetail;
